import BaseDataObject from './BaseDataObject';

// GameInformation shoe info
export default class ShoeInfo extends BaseDataObject {
  getHindshoes() {
    return this.getBoolean('hindshoes');
  }
  getLastRaceHindShoes() {
    return this.getBoolean('lastRaceHindshoes');
  }
  hasLastRaceHindShoes() {
    return this.has('lastRaceHindshoes');
  }
  getHindshoesChanged() {
    return (
      (this.has('hindshoes') && !this.has('lastRaceHindshoes')) ||
      this.getBoolean('lastRaceHindshoes') !== this.getBoolean('hindshoes')
    );
  }

  getForeshoes() {
    return this.getBoolean('foreshoes');
  }
  getLastRaceForeShoes() {
    return this.getBoolean('lastRaceForeshoes');
  }
  hasLastRaceForeShoes() {
    return this.has('lastRaceForeshoes');
  }
  getForeshoesChanged() {
    return (
      (this.has('foreshoes') && !this.has('lastRaceForeshoes')) ||
      this.getBoolean('lastRaceForeshoes') !== this.getBoolean('foreshoes')
    );
  }

  getShoesChanged() {
    return this.getForeshoesChanged() || this.getHindshoesChanged();
  }

  isAvailable() {
    return this.getBoolean('shoeInfoAvailable');
  }
}
